import React from 'react';
import { Link } from 'react-router-dom';

interface CardItemProps {
    cardImageSrc?: string;
    cardTitle?: string;
    cardContent?: string;
    link: string;
    photoConsent?: boolean;
}

const CardPhotoUpdate: React.FC<CardItemProps> = ({
    cardImageSrc,
    cardTitle,
    cardContent,
    link,
    photoConsent,
}) => {
    return (
        <div className='flex flex-col justify-between rounded-sm border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark'>
            <div>
                <Link to={link} className='block pb-3'>
                    <img
                        src={cardImageSrc}
                        alt={cardTitle}
                        className='h-[80px] w-[80px] rounded-full object-cover'
                    />
                </Link>

                <h4 className='mb-2 text-lg font-bold hover:text-primary dark:text-white dark:hover:text-primary'>
                    <Link to={link}>{cardTitle}</Link>
                </h4>

                <p className='mb-2'>{cardContent}</p>

                {photoConsent && (
                    <div
                        className='mb-4 inline-flex items-center gap-1 rounded-full bg-primary px-3 py-1 font-medium'
                        style={{ fontSize: '12px' }}
                    >
                        <svg
                            className='fill-current'
                            xmlns='http://www.w3.org/2000/svg'
                            width='18'
                            height='18'
                            viewBox='0 0 24 24'
                            fill='none'
                        >
                            <path
                                d='M9.59509 18L4 12.3119L5.39877 10.8898L9.59509 15.1559L18.6012 6L20 7.42204L9.59509 18Z'
                                fill=''
                            />
                        </svg>
                        Photo Consent
                    </div>
                )}
            </div>

            <Link to={link} className='text-primary'>
                Review
            </Link>
        </div>
    );
};

export default CardPhotoUpdate;
